export function temporarilyUpdateSelectRectStyle(rectAttribute, scene) {
    const {selectedRangeComponents: selectedRangeComponents} = scene;
    selectedRangeComponents.forEach(((selectComp, key) => {
        selectComp.rect.setAttributes(rectAttribute);
    })), scene.updateNextFrame();
}
//# sourceMappingURL=update-select-style.js.map
